import BaseModel from '../core/BaseModel'

export default class PropertyForSaleContactModel extends BaseModel {

    constructor() {
        super({
                name: "property_for_sale_contact",
                tableName: 'property_for_sale_contact',
                label: "Number of contacts",
                display_key: 'fullname_display',
                default_order: { key: 'created_at', direction: 'desc' }
            },
            {
                stt: {
                    name: "stt",
                    label: "No.",
                    type: "Computed",
                    computed: (data, index) => {
                        data.stt = index + 1;
                    },
                    width: 5,
                },
                id: {
                    name: 'id',
                    type: "Uuid",
                    label: 'ID',
                    primaryKey: true,
                    display: false
                },
                avatar: {
                    name: 'avatar',
                    type: "String",
                    label: 'Avatar',
                    width: 8,
                    custom: 'image'
                },
                fullname_display: {
                    name: 'fullname_display',
                    type: "String",
                    label: 'Fullname',
                    filter: { type: 'input', match: 'contains' },
                    width: 12,
                },
                phone_display: {
                    name: 'phone_display',
                    type: "String",
                    label: 'Phone',
                    filter: { type: 'input', match: 'contains' },
                    width: 12,
                },
                email_display: {
                    name: 'email_display',
                    type: "String",
                    label: 'Email',
                    filter: { type: 'input', match: 'contains' },
                    width: 14,
                },
                created_at: {
                    name: 'created_at',
                    type: "Datetime",
                    label: 'Contact date',
                    filter: { type: 'DateRange', match: 'contains' },
                    width: 16,
                },
                note: {
                    name: 'note',
                    type: "Text",
                    label: 'Note',
                    filter: { type: 'input', match: 'contains' },
                    width: 24,
                },
            })
    }
}
